import $ from 'jquery' // jQuery

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

import { Autoplay, Controller, EffectFade, Navigation, Pagination, EffectCoverflow, Thumbs, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, EffectCoverflow, Thumbs]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //  #####    ####
  //  ##  ##  ##
  //  #####   ##  ###
  //  ##  ##  ##   ##
  //  #####    ####

  /**
   * @function scrollValToggle
   * @description スクロール量を基準にクラスを着脱する
   * @param {String} targetSelector ターゲットとする一意なセレクタ
   * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
   * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
   * @param {String} toggleClass 切り替えるクラス名
   * @return {Void}
   */
  // #businessの下からの距離
  const bizPos = document.getElementById('business').getBoundingClientRect().top - 300

  console.log(bizPos)
  scrollValToggle('#topPara', bizPos, false, 'hide')

  function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
    if (!document.querySelector(targetSelector)) {
      return
    }
    let isExecute = false // 実行中フラグ
    let scrollY = 0 // 縦方向のスクロール量
    const target = document.querySelector(targetSelector) // ターゲット要素
    let scToggleActive = false // ターゲット要素のONOFF状態
    document.addEventListener('scroll', function (ev) {
      scrollValToggleApply()
    })
    scrollValToggleApply() // 初回起動
    function scrollValToggleApply() {
      if (isExecute) {
        // 実行中ならスキップ
        return
      }
      isExecute = true
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        scrollY = window.pageYOffset // スクロール量
        if (scrollY >= scrollValStart && !scToggleActive) {
          //トップから指定px以上スクロールしたらON
          target.classList.add(toggleClass)
          scToggleActive = true
        } else if (scrollY < scrollValStart && scToggleActive) {
          //スクロールが足りない時はOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
        if (scrollValEnd && scToggleActive) {
          // 終了ラインが設定されている場合は終了判定
          if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
            //スクロール終了範囲を過ぎていたらOFF
            target.classList.remove(toggleClass)
            scToggleActive = false
          }
        }
        isExecute = false
      })
    }
  }

  //  ###    ###  ##   ##
  //  ## #  # ##  ##   ##
  //  ##  ##  ##  ##   ##
  //  ##      ##   ## ##
  //  ##      ##    ###

  // テキスト部分
  const mvText = new Swiper('#topMvText', {
    speed: 300, // アニメ速度
    loop: true,
    slidesPerView: 1,
    direction: 'vertical',
    allowTouchMove: false,
    effect: 'slide',
    autoHeight: true, // スライドごとに高さを変動させる
    autoplay: {
      // オートオプション
      delay: 3000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
      // pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
      // stopOnLastSlide: true, // 最終スライドに到達したら停止する
    },
  })

  // 画像部分
  const mvImg = new Swiper('#toMvStaff', {
    speed: 1000,
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
  })

  // テキストがバウンドする演出と画像スライドの同期処理
  const topMvTextAnime = document.getElementById('topMvTextAnime')
  mvText.on('slideChangeTransitionStart', function (swiper) {
    const nowSlide = document.querySelector('#topMvText [data-swiper-slide-index="' + swiper['realIndex'] + '"]')

    if (nowSlide.classList.contains('on')) {
      // テキストがあるスライド
      topMvTextAnime.classList.remove('active')
      mvImg.slideNext() // 画像スライドを進める
    } else {
      // 縮む演出用の空白スライド
      topMvTextAnime.classList.add('active')
      setTimeout(() => {
        // オートの待機時間より早くスライドさせる
        mvText.slideNext()
      }, 400)
    }
  })

  //  #####   ##  ######
  //  ##  ##  ##     ##
  //  #####   ##    ##
  //  ##  ##  ##   ##
  //  #####   ##  ######

  const business = document.querySelector('#business')
  if (business) {
    ScrollTrigger.matchMedia({
      '(min-width: 768px)': function () {
        gsap.fromTo(
          '#business',
          {
            margin: '0 100px',
          },
          {
            margin: '0',
            scrollTrigger: {
              trigger: '#business',
              scrub: true,

              start: 'top-=500', // 開始位置を調整
              end: 'top-=100', // アニメーションの終了タイミング
            },
          }
        )
      },
    })
  }

  //  ##  ##     ##  ######
  //  ##  ####   ##    ##
  //  ##  ##  ## ##    ##
  //  ##  ##    ###    ##
  //  ##  ##     ##    ##
  const interviewSlider = new Swiper('.TopInterview__list', {
    slidesPerView: 'auto',
    spaceBetween: 60,
    centeredSlides: true, // 中央のスライドを基準にする
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      // ページャーオプション
      el: '.topInt-pagination', // ページャーを呼び出す要素
      type: 'fraction', // bullets,fraction(現ページ/ページ数),progressbar,custom
      clickable: true, // クリックでジャンプ可能にする
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        spaceBetween: 32,
      },
    },
  })

  //  ######    ###    ##      ##  ##
  //    ##     ## ##   ##      ## ##
  //    ##    ##   ##  ##      ####
  //    ##    #######  ##      ## ##
  //    ##    ##   ##  ######  ##  ##

  $('.TopCrossTalk__item-link').on('mouseover', function () {
    const src = $('.TopCrossTalk__img img').attr('src')
    const oldNo = src.slice(-6)
    const newNo = $(this).attr('data-src') + '.jpg'
    $('.TopCrossTalk__img img').attr('src', src.replace(oldNo, newNo))
  })

  //  #####   #####     #####
  //  ##  ##  ##  ##   ##   ##
  //  #####   #####    ##   ##
  //  ##      ##  ##   ##   ##
  //  ##      ##   ##   #####

  //             ####     ####    ###    #####
  //            ##       ##      ## ##   ##  ##
  //  ########  ##  ###   ###   ##   ##  #####
  //            ##   ##     ##  #######  ##
  //             ####    ####   ##   ##  ##

  const strSideScrollWrap = document.querySelector('.TopProject_scroll')
  if (strSideScrollWrap) {
    setSideScroll()
  }

  function setSideScroll() {
    const gsapMediaQuery = gsap.matchMedia() // GSAP用メディアクエリ
    gsap.registerPlugin(ScrollTrigger) // スクロールトリガー起動

    gsapMediaQuery.add('(min-width:769px)', () => {
      const panels = gsap.utils.toArray('.panel')
      const strSideScrollWrapWidth = strSideScrollWrap.offsetWidth
      const strSideScroll = gsap.to(panels, {
        xPercent: -30 * (panels.length - 2), // transformX
        ease: 'ease-out', // easingの設定
        // markers: true,
        scrollTrigger: {
          start: 'top-=150', // 開始位置を調整
          duration: 0.3,
          trigger: strSideScrollWrap, // アニメーションの対象となる要素
          pin: true, // 要素を固定する
          scrub: 1.2, // スクロールとアニメーションを同期させる。数値で秒数の設定に
          // snap: {
          //   // スナップスクロールにする
          //   snapTo: 1 / (panels.length - 1), // スナップで移動させる位置
          //   duration: { min: 0.1, max: 0.2 }, // スナップで移動する際の遅延時間
          //   ease: 'none', // easing
          // },
          end: 'top+=1200', // アニメーションの終了タイミング
        },
      })
    })
  }

  //             ####  ##      ##  ####    #####
  //            ##     ##      ##  ##  ##  ##
  //  ########   ###   ##      ##  ##  ##  #####
  //               ##  ##      ##  ##  ##  ##
  //            ####   ######  ##  ####    #####

  if (document.getElementById('proSlide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const slideItem = document.getElementById('proSlide')

    const sliderName = 'proSlide'
    const proSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（proSlideSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: false, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 1.2, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      spaceBetween: 20, //スライド同士の間隔を空ける
      centeredSlides: true, // 中央のスライドを基準にする
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}

/*
  ####### ######  ######  #####
  ##      ##      ##      ##   ##
  ######  #####   #####   ##   ##
  ##      ##      ##      ##   ##
  ##      ######  ######  #####
*/
function TimeConverter(UNIX_timestamp) {
  var a = new Date(UNIX_timestamp * 1000)
  var year = a.getFullYear()
  var month = a.getMonth()
  var date = a.getDate()
  var time = year + '.' + month + '.' + date
  return time
}
$('.sbi_item').each(function () {
  var timeStamp = $(this).data('date')
  if ($(this).find('.photo-date').length < 1)
    $(this).append(
      '<p class="photo-date flex vcenter hcenter"><i class="icon icon-1 icon-time"></i>' +
        TimeConverter(timeStamp) +
        '<i class="icon icon-2 icon-ins"></i></p>'
    )
})
